import {
  BaseDrawer,
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@spcc/uikit';
import type { AddressbookFilterDrawerProps } from '../types';

function normalizeSelectValue(value?: string) {
  return value && value.length > 0 ? value : 'all';
}

export function AddressbookFilterDrawer({
  open,
  onOpenChange,
  title,
  subtitle,
  statusLabel,
  typeLabel,
  cityLabel,
  statusOptions,
  typeOptions,
  cityOptions,
  selectedStatus,
  selectedType,
  selectedCityId,
  activeFilterCount,
  clearLabel,
  isRTL,
  onStatusChange,
  onTypeChange,
  onCityChange,
  onClearFilters,
}: AddressbookFilterDrawerProps) {
  const headerTitle =
    activeFilterCount > 0 ? `${title} (${activeFilterCount})` : title;

  const headerContent = (
    <div className="space-y-1">
      <h3 className="text-xl font-semibold text-white">{headerTitle}</h3>
      <p className="text-sm text-white/85">{subtitle}</p>
    </div>
  );

  const footerContent = (
    <div className="flex items-center justify-end">
      <Button
        type="button"
        variant="outline"
        onClick={onClearFilters}
        className="w-full sm:w-auto"
      >
        {clearLabel}
      </Button>
    </div>
  );

  return (
    <BaseDrawer
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      side="right"
      isRTL={isRTL}
      fixedWidth={420}
      tabletWidth="84%"
      mobileWidth="100%"
      headerGradient="from-slate-800 to-slate-700"
      headerContent={headerContent}
      footerContent={footerContent}
      contentClassName="space-y-5"
      modal={false}
    >
      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">{statusLabel}</p>
        <Select
          value={normalizeSelectValue(selectedStatus)}
          onValueChange={onStatusChange}
        >
          <SelectTrigger className="h-11">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {statusOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">{typeLabel}</p>
        <Select
          value={normalizeSelectValue(selectedType)}
          onValueChange={onTypeChange}
        >
          <SelectTrigger className="h-11">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {typeOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">{cityLabel}</p>
        <Select
          value={normalizeSelectValue(selectedCityId)}
          onValueChange={onCityChange}
        >
          <SelectTrigger className="h-11">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {cityOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </BaseDrawer>
  );
}
